import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";
import { type BaseLeaveRequest } from "@/lib/collections/requestsLeave/types";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const LEAVES_COLLECTION_ID = import.meta.env.VITE_LEAVES_REQUESTS_COLLECTION_ID;

export type LeaveRequest = BaseLeaveRequest;

export interface GetAllLeaveRequestsResponse {
    success: boolean;
    data?: LeaveRequest[];
    error?: string;
}

/**
 * Obtiene TODAS las solicitudes de permiso para RRHH
 */
export async function getAllLeaveRequests(): Promise<GetAllLeaveRequestsResponse> {
    try {
        const response = await databases.listDocuments(
            DATABASE_ID,
            LEAVES_COLLECTION_ID,
            [Query.limit(500)]

        );

        return {
            success: true,
            data: response.documents as unknown as LeaveRequest[]
        };
    } catch (error) {
        console.error("Error fetching all leave requests:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido'
        };
    }
}

export async function getLeaveById(leaveId: string): Promise<LeaveRequest> {
    const doc = await databases.getDocument(
        DATABASE_ID,
        LEAVES_COLLECTION_ID,
        leaveId
    );
    return doc as unknown as LeaveRequest;
}